/* global process */
import 'es6-promise/auto'; // eslint-disable-line import/no-unassigned-import
import Vue from 'vue';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import dotProp from 'dot-prop';
import loadScript from 'gso-script-loader';
// Need to import the URL polyfill here as
// it's used to load the polyfills...
import 'js-polyfills/url'; // eslint-disable-line import/no-unassigned-import
import Header from 'gso-header';
import headerPlugin from 'gso-header/plugin';
import resolveUrl from 'gso-header/src/resolve-url';
import userLanguage from 'gso-user-language';
import {read} from 'gso-session';
import {version} from '../package.json';
// eslint-disable-next-line import/no-unresolved
import polyfills from '../gso-header-polyfill-all.json';

const headerElement = document.querySelector<HTMLElement>('#gso-header');
const baseUrl = headerElement.dataset.baseUrl;

Vue.config.errorHandler = function(err, vm, info) {
	console.error(err, vm, info);
};

async function main(): Promise<void> {
	Vue.use(Vuex);
	Vue.use(VueI18n);
	const store = new Vuex.Store({});

	const i18n = new VueI18n({
		locale: userLanguage(),
		messages: {en: {}, fr: {}, nl: {}}
	});

	Vue.use(headerPlugin, {store, i18n});

	store.commit('header/setBaseUrl', {baseUrl});

	const app = new Vue({
		store,
		i18n,
		render: h =>
			h(Header, {
				class: 'gso-header-app',
				props: {helpHref: headerElement.dataset.helpHref}
			})
	});
	app.$mount('#gso-header');
}

// eslint-disable-next-line no-console
console.log(`Loading gso-header version ${version}`);

/// ///////////////////////////
/// New React Header logic ///
/// ///////////////////////////

const displayNewReactHeader = Boolean(
	JSON.parse(localStorage.getItem('FR-SDK-portal_frontend') || '{}')
		.accessToken
);
// eslint-disable-next-line no-console
console.log('Display new React Header ?', displayNewReactHeader);

function getReactHeaderScriptUrl(): string {
	const pageHost = window.location.host.toString();
	if (
		pageHost.includes('localhost') ||
		pageHost.includes('devservices') ||
		pageHost.includes('devonline')
	) {
		return 'https://devonline.groups.local/portal/header/gso-react-header.min.js';
	} else if (pageHost.includes('qaservices') || pageHost.includes('qaonline')) {
		return 'https://qaonline.groups.be/portal/header/gso-react-header.min.js';
	} else if (pageHost.includes('services') || pageHost.includes('online')) {
		return 'https://online.groups.be/portal/header/gso-react-header.min.js';
	}
}

function loadNewReactHeaderScript(): void {
	const script = document.createElement('script');
	script.src = getReactHeaderScriptUrl();
	document.head.append(script);
}

/// //////////////////////////////////////
/// Mounting the correct Header logic ///
/// //////////////////////////////////////

if (displayNewReactHeader) {
	loadNewReactHeaderScript();
} else if (
	polyfills.every(polyfill => {
		return dotProp.has(window, polyfill);
	})
) {
	main();
} else {
	loadScript(resolveUrl(`../gso-header/gso-header-polyfill.js`, baseUrl), main);
}
